import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const exclusiveArticles = articles.filter((a) => a.tags.includes('独家') || a.category === 'dujia-jiemi').slice(0, 4);

export default function ExclusiveSection() {
  return (
    <section className="py-14 md:py-18 bg-foreground-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div className="lg:w-[70%]">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-background-50/30 text-background-50 text-xs font-medium whitespace-nowrap mb-5">
              <i className="ri-vip-crown-line text-xs"></i>
              爆瓜独家
            </span>
            <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight">
              独家 · 深度
            </h2>
          </div>
          <Link
            to="/category/dujia-jiemi"
            className="inline-flex items-center gap-2 text-background-50/60 text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部独家内容
            <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4">
          {exclusiveArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex-shrink-0 w-[280px] md:w-[300px] group cursor-pointer"
            >
              <div className="rounded-xl overflow-hidden mb-4">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <h3 className="text-background-50 text-sm font-medium leading-snug line-clamp-2 mb-2 group-hover:text-primary-400 transition-colors duration-200">
                {article.title}
              </h3>
              <div className="flex items-center gap-3 text-background-50/40 text-xs">
                <span className="whitespace-nowrap">{article.author}</span>
                <span>·</span>
                <span className="whitespace-nowrap">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}